export default "__VITE_ASSET__DOHyYZ6w__"